import React from 'react'
import { Query } from 'react-apollo'
import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import Select from 'react-select'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { CircularProgress } from '@material-ui/core'
import TextField from '@material-ui/core/TextField'
import Switch from '@material-ui/core/Switch'
import { GET_SOLUTION_TYPES, GET_SOLUTION_TYPES_WITH_PLANS, GET_RCS_INVENTORY } from './queries'

const SolutionTypeOption = props => {
    const { onSelect, onFocus, isSelected, option, children, className } = props
    const handleMouseDown = event => {
        event.preventDefault()
        event.stopPropagation()
        onSelect(option, event)
    }
    const handleMouseEnter = event => {
        onFocus(option, event)
    }

    return (
        <div
            className={className}
            onMouseDown={handleMouseDown}
            onMouseEnter={handleMouseEnter}
            onMouseMove={handleMouseEnter}
            title={option.title}
            style={{ display: 'flex', alignItems: 'center' }}
        >
            <Checkbox checked={!!isSelected} color="primary" />
            <span>{children}</span>
        </div>
    )
}



const InstallationSubmissionStep = ({
    state,
    classes,
    handleInputChange,
    handleChange,
    handleImmobilizeChange
}) => {
    return (
        <React.Fragment>
            <Grid item xs={12} sm={12}>
                <h3 className="Formheader" style={{ textAlign: 'left', marginBottom: '20px' }}>
                    Payment Details & Submission
                </h3>
            </Grid>
            <Grid container fullwidth="true" style={{ marginTop: '20px' }}>
                <Grid item xs={12} sm={6}>
                    <FormControl className="selectbox">
                        <FormGroup className="form-input" style={{ marginTop: '5px' }}>
                            <div style={{ marginTop: '20px' }}>Solution Type *</div>
                            <div style={{ marginTop: '5px' }}>
                                <Query query={GET_SOLUTION_TYPES}>
                                    {({ loading, error, data }) => {
                                        if (loading) return <CircularProgress size={24} />
                                        if (error) return <div>Error loading solution types</div>

                                        const solutionTypeMultiOptions = data.getAllMasterSolutionType
                                            .map(
                                                type => {
                                                    const code = type.id

                                                    return {
                                                        value: type.id,
                                                        label: type.solutionTypeName,
                                                        code: code
                                                    }
                                                }
                                            )

                                        const selectedMultiValue = solutionTypeMultiOptions.filter(
                                            option =>
                                               state.selected_solution_codes &&
                                               state.selected_solution_codes.includes(option.code)
                                        )

                                        return (
                                            <Select
                                                id="solution_type"
                                                name="solution_type"
                                                classes={classes}
                                                options={solutionTypeMultiOptions}
                                                value={selectedMultiValue}
                                                multi
                                                optionComponent={SolutionTypeOption}
                                                closeOnSelect={false}
                                                removeSelected={false}
                                                onChange={handleInputChange('solution_type')}
                                                placeholder="Solution Type *"
                                            />
                                        )
                                    }}
                                </Query>
                                {state.solution_type &&
                                    state.solution_type.some(s => ['video_telematics', 'fuel+vt', 'obd+vt', 'fuel+obd+vt'].includes(s)) &&
                                    !state.videoTelematicsId && (
                                        <p style={{ color: 'red', fontSize: '12px', margin: '4px 0 0' }}>
                                            Video Telematics ID is mandatory for the selected solution type.
                                        </p>
                                    )
                                }
                                {/* If reverse camera selected, show RCS Serial Number dropdown */}
                                {state.solution_type && state.solution_type.includes('reverse_camera_screen') && (
                                    <div style={{ marginTop: '12px' }}>
                                        <Query query={GET_RCS_INVENTORY} fetchPolicy="network-only">
                                            {({ loading, error, data }) => {
                                                if (loading) return <CircularProgress size={20} />
                                                if (error) return <div>Error loading RCS inventory</div>

                                                const options = (data && data.getReverseCameraAndScreenInventory && data.getReverseCameraAndScreenInventory.data) ? data.getReverseCameraAndScreenInventory.data.map(item => ({ value: item.rcs_serial_number, label: item.rcs_serial_number })) : []

                                                return (
                                                    <div style={{ marginTop: '8px' }}>
                                                        <div style={{ marginBottom: '6px' }}>RCS Serial Number</div>
                                                        <Select
                                                            options={options}
                                                            value={options.find(o => o.value === state.rcsSerialNumber) || null}
                                                            onChange={handleInputChange('rcsSerialNumber')}
                                                            placeholder="Select RCS Serial Number"
                                                            isClearable
                                                        />
                                                    </div>
                                                )
                                            }}
                                        </Query>
                                    </div>
                                )}
                            </div>
                        </FormGroup>
                    </FormControl>
                </Grid>


            </Grid>

            <Grid container fullwidth="true" style={{ marginTop: '20px' }}>
                {/* Plans for each solution type - hardcoded to 1 Year as requested */}
                {state.solution_type && state.solution_type.length > 0 && (
                    state.solution_type.map(selectedSolutionCode => {
                        // Use reverse mapping for a nicer name if available, otherwise clean up the code itself
                        const descriptiveName =  selectedSolutionCode
                        
                        // Format the label nicely (e.g., 'fuel_solution' -> 'FUEL SOLUTION')
                        const solutionLabel = descriptiveName
                            .toString()
                            .replace(/_/g, ' ')
                            .replace(/\+/g, ' & ')
                            .toUpperCase()

                        return (
                            <Grid item xs={12} sm={6} key={selectedSolutionCode}>
                                <FormControl className="selectbox">
                                    <FormGroup className="form-input" style={{ marginTop: '5px' }}>
                                        <div style={{ marginTop: '20px', fontSize: '14px', fontWeight: 500, color: '#555' }}>
                                            {solutionLabel} Plan
                                        </div>
                                        <div style={{ marginTop: '8px' }}>
                                            <div style={{
                                                padding: '12px 16px',
                                                backgroundColor: '#f8f9fa',
                                                border: '1px solid #dee2e6',
                                                borderRadius: '8px',
                                                fontWeight: 600,
                                                color: '#212529',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                fontSize: '14px',
                                                boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                                            }}>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <span style={{ 
                                                        width: '8px', 
                                                        height: '8px', 
                                                        backgroundColor: '#28a745', 
                                                        borderRadius: '50%', 
                                                        marginRight: '10px' 
                                                    }}></span>
                                                    <span>1 Year Plan Selected</span>
                                                </div>
                                                <span style={{ 
                                                    fontSize: '11px', 
                                                    backgroundColor: '#e9ecef', 
                                                    padding: '2px 8px', 
                                                    borderRadius: '10px',
                                                    color: '#6c757d',
                                                    textTransform: 'uppercase'
                                                }}>Auto</span>
                                            </div>
                                        </div>
                                    </FormGroup>
                                </FormControl>
                            </Grid>
                        )
                    })
                )}
            </Grid>

            <Grid container fullwidth="true" style={{ marginTop: '20px' }}>
                <Grid item xs={12} sm={6}>
                    <Grid item xs={12} sm={12}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={state.installStatus}
                                    onChange={handleChange('installStatus')}
                                    value="installStatus"
                                    color="primary"
                                />
                            }
                            label="Installation Completed"
                        />
                    </Grid>
                    {state.vehicleSegment !== 'DG Set' && (
                        <Grid item xs={12} sm={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={state.immobilize}
                                        onChange={handleImmobilizeChange('immobilize')}
                                        value="immobilize"
                                        color="primary"
                                    />
                                }
                                label="Immobilizable"
                            />
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </React.Fragment>
    )
}

export default InstallationSubmissionStep



// WEBPACK FOOTER //
// ./src/components/Modules/VehicleRegistartion/InstallationSubmissionStep.jsx